import { createSlice } from "@reduxjs/toolkit";

export const diviceUserSlice = createSlice({
    name: "divice",
    initialState: {
        divice: "",
    },
    reducers: {
        getDivice: (state, action) => {
            return { ...state, divice: action.payload, };
        }
    },
});

export const { getDivice } = diviceUserSlice.actions;


export default diviceUserSlice.reducer;
